import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { StopUnit } from "../../../../ducks/app/cargo-and-template-shared";
import { selectAllStopUnitTemplates } from "../../../../ducks/data/stop-unit-templates/selectors";
import { useSelector } from "../../../../redux-store";
import { DoraButton } from "dora-shared/frontend";
import StopUnitContent from "./StopUnitContent";

type Props = {
  availablePickupUnits: StopUnit[];
  stopUnitsWatch: StopUnit[];
  onAssign: (unitIndex: number) => void;
  onClose: () => void;
};

const AssignStopUnitsDialog = ({
  availablePickupUnits,
  stopUnitsWatch,
  onAssign,
  onClose,
}: Props) => {
  const { t } = useTranslation(["stopUnits", "components"]);
  const allUnitTemplates = useSelector(selectAllStopUnitTemplates);

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{t("stopUnits:assignDialog.title")}</DialogTitle>
      <DialogContent>
        <div className="shipment-cargo-form__stop-units-table">
          <div className="stop-unit-line-row stop-unit-line-row--header">
            <div className="stop-unit-line-row-cell">
              {t("stopUnits:columns.qty")}
            </div>
            <div className="stop-unit-line-row-cell">
              {t("stopUnits:columns.unit")}
            </div>
            <div className="stop-unit-line-row-cell">
              {t("stopUnits:columns.description")}
            </div>
            <div className="stop-unit-line-row-cell">
              {t("stopUnits:columns.colli")}
            </div>
            <div className="stop-unit-line-row-cell">
              {t("stopUnits:columns.weightAbbr")}
            </div>
            <div className="stop-unit-line-row-cell">
              {t("stopUnits:columns.dimsAbbr")}
            </div>
            <div className="stop-unit-line-row-cell" style={{ display: "flex" }}>
              <span>V,m</span>
              <sup>3</sup>
            </div>
            <div className="stop-unit-line-row-cell">
              {t("stopUnits:columns.actions")}
            </div>
          </div>
          {availablePickupUnits.map((unit) => {
            const unitIndex = stopUnitsWatch.findIndex(
              (u: StopUnit) => u.id === unit.id
            );
            const unitTemplate = allUnitTemplates.find(
              (ut) => ut.id === unit.stopUnitTemplateId
            );
            return (
              <div key={unit.id} className="stop-unit-line-row">
                <StopUnitContent
                  unit={{ ...unit, name: unitTemplate?.name || "" }}
                />
                <div className="stop-unit-template-line-row-cell shipment-cargo-form__stop-unit-actions">
                  <DoraButton
                    variant="primary-filled"
                    onClick={() => onAssign(unitIndex)}
                  >
                    {t("stopUnits:assignDialog.assignButton")}
                  </DoraButton>
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
      <DialogActions>
        <DoraButton variant="primary" onClick={onClose}>
          {t("components:buttonLabels.close")}
        </DoraButton>
      </DialogActions>
    </Dialog>
  );
};

export default AssignStopUnitsDialog;
